import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class LocalStorageFacade {
  private readonly actuarPrefixKey = 'actuar/';
  private readonly customEventName = 'actuar-storage';

  // private emitChange(key: string, value: string | null): void {
  //   try {
  //     if (typeof window !== 'undefined' && 'dispatchEvent' in window) {
  //       window.dispatchEvent(new CustomEvent(this.customEventName, { detail: { key, value } }));
  //     }
  //   } catch {
  //     // noop in non-browser or event dispatch failure
  //   }
  // }

  public setItem(key: string, value: any): void {
    const _key: string = this.actuarPrefixKey + key;
    localStorage.setItem(_key, value);
    // this.emitChange(_key, value);
  }

  public getItem(key: string): any {
    const _key: string = this.actuarPrefixKey + key;
    return localStorage.getItem(_key);
  }

  public removeItem(key: string): void {
    const _key: string = this.actuarPrefixKey + key;
    localStorage.removeItem(_key);
    // this.emitChange(_key, null);
  }

  public clearAllData(): void {
    localStorage.clear();
    // this.emitChange('*', null);
  }
}
